import { NgxPermissionsService } from 'ngx-permissions';

import { Inject, Injectable } from '@angular/core';
import {
  BaseSharedEntityFacade,
  SharedEntityActions,
  SharedEntityStateSelectors,
} from '@ideapa/app-base-components';
import { SharedEntityFacadeInterface } from '@ideapa/app-common';
import { RouterFacade } from '@ideapa/app-routing-utils';
import { Store } from '@ngrx/store';

import {
  ENTITY_NAME_TOKEN,
  SHARED_ENTITY_ACTIONS_TOKEN,
  SHARED_ENTITY_SELECTORS_TOKEN,
} from './constants';
import { UtenteEnte as Entity } from './models';
import { State } from './reducer';

@Injectable()
export class SharedFacade
  extends BaseSharedEntityFacade<Entity, State>
  implements SharedEntityFacadeInterface<Entity>
{
  constructor(
    store: Store<State>,
    permissionsService: NgxPermissionsService,
    routerFacade: RouterFacade,
    @Inject(SHARED_ENTITY_SELECTORS_TOKEN)
    selectors: SharedEntityStateSelectors<Entity, State>,
    @Inject(SHARED_ENTITY_ACTIONS_TOKEN)
    actions: SharedEntityActions<Entity>,
    @Inject(ENTITY_NAME_TOKEN)
    entityName: string
  ) {
    super(
      store,
      permissionsService,
      routerFacade,
      selectors,
      actions,
      entityName
    );
  }
}
